// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    TRANSACTIONS_DETAILS_RESULT_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    transactionsDetailsResult,
} from 'Redux/actions';

// Helpers
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* transactionsDetailsSearch({ payload }) {

    try {
        const { transactionId, nextToken, type } = payload;
        let currentdata = [];
        let queryParams = {};
        let TRANSACTIONS_RESULTS = ""

        if (type !== "ReprocessOdoHrs" && type !== "RecalculateOdometerHours") {
            TRANSACTIONS_RESULTS = `
                query($searchBy: enumTransactionSearchBy!, $transactionId: String, $status: String, $type: String, $dateRange: AWSDateTimeRange, $limit: Int, $nextToken: String){
                    Transactions: searchTransactions (searchBy: $searchBy, transactionId: $transactionId, status: $status, type: $type, dateRange: $dateRange, limit: $limit, nextToken: $nextToken){
                        nextToken
                        items{
                            TransactionId
                            Type
                            Data
                            Status
                            Message
                            CreatedOn
                            CreatedBy
                        }
                    }
                }    
            `;

            queryParams = {
                searchBy: "TransactionId",
                transactionId: transactionId,
                limit: 50,
                nextToken: nextToken,
            }

        } else {
            TRANSACTIONS_RESULTS = `
                query getReprocessOdoHrsDetails ($transactionId: String!) {
                    Transactions: getReprocessOdoHrsDetails (transactionId: $transactionId) {
                        transactionId 
                        accountId 
                        startDate 
                        endDate 
                        processed 
                        errorMsg 
                        priority 
                        processedDate 
                        processId 
                        unitId 
                        mode
                    }
                }    
            `;

            queryParams = {
                transactionId: transactionId
            }
        }

        let data = yield call(
            clientQuery,
            TRANSACTIONS_RESULTS,
            queryParams,
            endpoints.GRAPHQL_GENERAL,
        );

        let nxtToken = null;
        //To map the main items that comes in the Data as a json
        if (data) {
            if (type !== "ReprocessOdoHrs" && type !== "RecalculateOdometerHours") {
                currentdata = data?.Transactions || { nextToken: null, items: [] };
                nxtToken = data?.Transactions?.nextToken

                let createNotificationType = currentdata?.items.length ? currentdata?.items.some((item) => item.Type === "CreateNotification") : false
                if (createNotificationType) {
                    try {
                        const recipients = currentdata?.items.flatMap(transaction => {
                            const data = JSON.parse(transaction.Data);
                            return data.to.flatMap(entry => entry.recipients.map(recipient => recipient.to));
                        });
                        if (recipients.length) {
                            let QUERY_SMS_DETAILS = `
                                query getSMSDetails ($type: enumSimSearchType!, $entities: [String]!) {
                                    result: getSMSDetails (type: $type, entities: $entities) {
                                        items {
                                            unitId
                                            companyId
                                            iccid
                                            msisdn
                                            in
                                            out
                                        }
                                    }
                                }
                            `;
                            let smsDetails = yield call(
                                clientQuery,
                                QUERY_SMS_DETAILS,
                                {
                                    type: "ICCID",
                                    entities: recipients
                                },
                                endpoints.GRAPHQL_GENERAL,
                            );

                            /* let dummyData = {
                                "items": [
                                    {
                                        "unitId": "200079886",
                                        "companyId": 21317,
                                        "iccid": "89011703278117812084",
                                        "msisdn": "882350811781208",
                                        "in": "[{\"targetEntityNameId\":\"Unit_200079886\",\"projectId\":\"PM\",\"targetEntityName\":\"Unit\",\"updatedOn\":\"2024-06-26T21:28:33.283Z\",\"companyId\":\"21317\",\"status\":\"Delivered\",\"via_createdOn\":\"SMS_MO_RECEIVED_2024-06-26T21:28:33.283Z\",\"contact\":\"\",\"systemName\":\"\",\"ttl\":1727213313,\"targetEntityNameId_via_createdOn\":\"Unit_200079886_SMS_MO_RECEIVED_2024-06-26T21:28:33.283Z\",\"updatedBy\":\"system\",\"message\":\"INB:52.52.153.84:10522 LMD\\nAPP2:REV10518-REL\",\"createdBy\":\"system\",\"via\":\"SMS_MO_RECEIVED\",\"system_createdOn\":\"0_2024-06-26T21:28:33.283Z\",\"system\":\"0\",\"messageId\":\"SMS_MO_RECEIVED-394643245001\",\"createdOn\":\"2024-06-26T21:28:33.283Z\",\"targetEntityId\":200079886,\"description\":\"SMS_MO_RECEIVED Notification\",\"to\":\"4572134654\",\"id\":\"b2b344aa-6196-486e-a972-cc01fd93f605\"},{\"targetEntityNameId\":\"Unit_200079886\",\"projectId\":\"PM\",\"targetEntityName\":\"Unit\",\"updatedOn\":\"2024-06-26T21:28:32.079Z\",\"companyId\":\"21317\",\"status\":\"Delivered\",\"via_createdOn\":\"SMS_MO_RECEIVED_2024-06-26T21:28:32.079Z\",\"contact\":\"\",\"systemName\":\"\",\"ttl\":1727213312,\"targetEntityNameId_via_createdOn\":\"Unit_200079886_SMS_MO_RECEIVED_2024-06-26T21:28:32.079Z\",\"updatedBy\":\"system\",\"message\":\"APP:434 8.6f\\nCOM:-67 DA. GPSTRACKIT01.COM.ATTZ\\nGPS:3D-DIFF  17\\nINP:0000000000000000 12.7V\\nMID:4572134654 ESN\\n\",\"createdBy\":\"system\",\"via\":\"SMS_MO_RECEIVED\",\"system_createdOn\":\"0_2024-06-26T21:28:32.079Z\",\"system\":\"0\",\"messageId\":\"SMS_MO_RECEIVED-394643237501\",\"createdOn\":\"2024-06-26T21:28:32.079Z\",\"targetEntityId\":200079886,\"description\":\"SMS_MO_RECEIVED Notification\",\"to\":\"4572134654\",\"id\":\"7a98f1a4-c823-486f-a6af-67b2ec032706\"}]",
                                        "out": "{\"targetEntityNameId\":\"OPEN_89011703278117812084\",\"projectId\":\"PM\",\"targetEntityName\":\"OPEN\",\"updatedOn\":\"2024-06-26T21:28:26.279Z\",\"companyId\":\"undefined\",\"status\":\"Processed\",\"ttl\":1727213306,\"updatedBy\":\"PM_34\",\"createdBy\":\"PM_34\",\"system_createdOn\":\"5_2024-06-26T21:28:26.279Z\",\"errorCode\":\"\",\"messageId\":\"394643202201\",\"errorMessage\":\"\",\"id\":\"ea6bba9c-60e1-4837-ad73-35877e6123af\",\"contact\":\"\",\"via_createdOn\":\"SMS_2024-06-26T21:28:26.279Z\",\"systemName\":\"AT&T smpp\",\"targetEntityNameId_via_createdOn\":\"OPEN_89011703278117812084_SMS_2024-06-26T21:28:26.279Z\",\"message\":\"!R0\",\"via\":\"SMS\",\"system\":5,\"createdOn\":\"2024-06-26T21:28:26.279Z\",\"targetEntityId\":\"89011703278117812084\",\"description\":\"SMS Notification\",\"to\":\"89011703278117812084\"}"
                                    }
                                ]
                            } */

                            /* if (dummyData?.items?.length) {
                                let items = dummyData?.items
                                currentdata = {
                                    ...currentdata,
                                    items: currentdata?.items.map((item) => {
                                        const data = JSON.parse(item.Data);
                                        let newData
                                        data.to.forEach(entry => {
                                            entry.recipients.forEach(recipient => {
                                                const matchingNewData = items.find(newData => newData.iccid === recipient.to);
                                                if (matchingNewData) {
                                                    newData = matchingNewData;
                                                }
                                            });
                                        });
                                        return {
                                            ...item,
                                            newData
                                        }
                                    })
                                }
                            } */

                            if (smsDetails?.result?.items?.length) {
                                let items = smsDetails?.result?.items
                                currentdata = {
                                    ...currentdata,
                                    items: currentdata?.items.map((item) => {
                                        const data = JSON.parse(item.Data);
                                        let newData
                                        data.to.forEach(entry => {
                                            entry.recipients.forEach(recipient => {
                                                const matchingNewData = items.find(newData => newData.iccid === recipient.to);
                                                if (matchingNewData) {
                                                    newData = matchingNewData;
                                                }
                                            });
                                        });
                                        return {
                                            ...item,
                                            newData
                                        }
                                    })
                                }
                            }
                        }
                    } catch (exc) { }
                }

            } else {
                currentdata = { nextToken: null, items: data?.Transactions || [] };
            }
        }

        yield put(transactionsDetailsResult({ transactions: currentdata?.items, nextToken: nxtToken, oldNextToken: nextToken }));
    } catch (exc) {
        yield put(transactionsDetailsResult({ error: exc }));
        ExceptionManager(exc,
            "Modules/transactions/views/transactionDetails/redux/saga/",
            "transactionsDetailsSearch")
    }
}

function* watchMethods() {
    yield takeEvery(TRANSACTIONS_DETAILS_RESULT_REQUEST, transactionsDetailsSearch);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}